export const LOVEMO_FALLBACK_ORIGIN = "https://www.lovemoai.net";

export const LOVEMO_OG_IMAGE_PATH = "/images/lovemo-logo.png";

export type LovemoSchemaKind = "software" | null;

export interface LovemoSeoData {
  title: string;
  description: string;
  keywords: string;
  noindex: boolean;
  ogTitle: string;
  ogDescription: string;
  twitterTitle: string;
  twitterDescription: string;
  schemaKind: LovemoSchemaKind;
}

export function getLovemoSiteOrigin(): string {
  const env = import.meta.env as Record<string, string | undefined>;
  const raw = env.VITE_SITE_URL;
  if (typeof raw === "string" && raw.trim()) {
    return raw.trim().replace(/\/+$/, "");
  }
  return LOVEMO_FALLBACK_ORIGIN;
}

export function getLovemoSocialImage(): string {
  return `${getLovemoSiteOrigin()}${LOVEMO_OG_IMAGE_PATH}`;
}

export const LOVEMO_HOME_SEO: LovemoSeoData = {
  title: "Lovemo官网 - 懂你情绪的AI陪伴助手",
  description:
    "Lovemo 是一款懂情绪的AI陪伴聊天工具，支持 Android、iOS、HarmonyOS、Windows 全平台。提供Lovemo官方正版免费下载与Lovemo下载教程，安全无弹窗，随时陪你聊。",
  keywords: "Lovemo",
  noindex: false,
  ogTitle: "Lovemo官网 - Lovemo官方正版免费下载 | AI情感陪伴聊天工具",
  ogDescription:
    "懂你情绪的 AI 陪伴工具 Lovemo，支持多平台免费下载。查看 Lovemo下载教程，获取官方正版最新版本。",
  twitterTitle: "Lovemo官网 - Lovemo官方正版免费下载",
  twitterDescription:
    "懂你情绪的 AI 陪伴工具 Lovemo，支持 Android、iOS、HarmonyOS、Windows 免费下载。",
  schemaKind: "software",
};

export const LOVEMO_REPORT_SEO: LovemoSeoData = {
  title: "投诉举报 - Lovemo",
  description:
    "Lovemo 官方投诉举报通道，可提交产品侵权、虚假官网、低俗色情、欺诈交易等问题，我们会尽快核实处理。",
  keywords: "Lovemo投诉举报,Lovemo官方",
  noindex: true,
  ogTitle: "投诉举报 - Lovemo",
  ogDescription:
    "Lovemo 官方投诉举报通道，可提交产品侵权、虚假官网、低俗色情、欺诈交易等问题，我们会尽快核实处理。",
  twitterTitle: "投诉举报 - Lovemo",
  twitterDescription: "Lovemo 官方投诉举报通道，我们会尽快核实处理。",
  schemaKind: null,
};

export const LOVEMO_FALLBACK_SEO: LovemoSeoData = {
  title: "Lovemo官网 - 懂你情绪的AI陪伴助手",
  description:
    "Lovemo 是一款懂情绪的AI陪伴聊天工具，支持 Android、iOS、HarmonyOS、Windows 全平台，提供官方正版免费下载与下载教程。",
  keywords: "Lovemo",
  noindex: true,
  ogTitle: "Lovemo官网 - 懂你情绪的AI陪伴助手",
  ogDescription: "Lovemo 是一款懂情绪的AI陪伴聊天工具，支持多平台官方正版免费下载。",
  twitterTitle: "Lovemo官网 - 懂你情绪的AI陪伴助手",
  twitterDescription: "Lovemo 是一款懂情绪的AI陪伴聊天工具，支持多平台官方正版免费下载。",
  schemaKind: null,
};

export function resolveLovemoSeo(pathname: string): LovemoSeoData {
  if (pathname === "/") return LOVEMO_HOME_SEO;
  if (pathname === "/report") return LOVEMO_REPORT_SEO;
  return LOVEMO_FALLBACK_SEO;
}

export function buildLovemoCanonical(pathname: string): string {
  const origin = getLovemoSiteOrigin();
  const clean = pathname.replace(/\/+$/, "");
  if (!clean || clean === "") return `${origin}/`;
  return `${origin}${clean}`;
}